export const ResourcesLink = `https://www.floridainclusionnetwork.com/school-bpie-admin-files/`;